import React, { PropTypes } from 'react';
import Stamp from '@alias/Stamp';
import classNames from 'classnames';
import WatchPropTypes from 'common/PropTypes';

// The description has the exact html for the Hero and Playback items, but different classnames
const HtmlClassMap = {
    HERO: {
        figcaption: 'hero_detail',
        wrapper: 'hero_detail-wrap',
        title: 'hero_title',
        meta: 'hero_meta',
        truncate: 'hero_truncate',
        network: 'hero_network',
        event: 'hero_event'
    },
    PLAYBACK: {
        figcaption: 'playback__figcaption',
        wrapper: 'playback__wrapper',
        title: 'playback__title',
        meta: 'playback__meta',
        truncate: 'playback_truncate',
        network: '',
        event: ''
    }
};

const ContentMetadataLarge = ({
    blurredImage,
    title,
    subtitle,
    content,
    isHero,
    showLock,
    userIsBlackedOut
}) => {
    const context = isHero ? 'HERO' : 'PLAYBACK';
    const metaDataClass = classNames(HtmlClassMap[context].meta, 'icon-font-before', {
        'icon-lock-solid-before': showLock
    });

    return (
        <figcaption className={HtmlClassMap[context].figcaption}>
            <Stamp content={content} userIsBlackedOut={userIsBlackedOut} />
            {blurredImage}
            <div className={HtmlClassMap[context].wrapper}>
                <div className={HtmlClassMap[context].title}>{title}</div>
                <div className={metaDataClass}>
                    <div className={HtmlClassMap[context].truncate}>
                        {subtitle && <span>{subtitle}</span>}
                    </div>
                </div>
            </div>
        </figcaption>
    );
};

ContentMetadataLarge.propTypes = {
    blurredImage: PropTypes.element,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: WatchPropTypes.content,
    isHero: PropTypes.bool,
    showLock: PropTypes.bool,
    userIsBlackedOut: PropTypes.bool
};

ContentMetadataLarge.defaultProps = {
    blurredImage: null,
    title: '',
    subtitle: ''
};

export default ContentMetadataLarge;



// WEBPACK FOOTER //
// ./app/common/page/hero/ContentMetadataLarge.js